import { render, staticRenderFns } from "./MemberHeader.vue?vue&type=template&id=88fe94ac&scoped=true&"
import script from "./MemberHeader.vue?vue&type=script&lang=js&"
export * from "./MemberHeader.vue?vue&type=script&lang=js&"
import style0 from "./MemberHeader.vue?vue&type=style&index=0&id=88fe94ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fe94ac",
  null
  
)

export default component.exports